// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"bd6ef52a","284":"aa0a0c95"}[chunkId] + ".chunk.js";
};